import { isAnonymousTimestampJitterEvent } from './policy';

const TIMESTAMP_JITTER_MIN_SECONDS = 60;
const TIMESTAMP_JITTER_MAX_SECONDS = 600;

const randomIntegerInclusive = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const buildAnonymousTimestampJitterMs = (): number =>
  randomIntegerInclusive(TIMESTAMP_JITTER_MIN_SECONDS, TIMESTAMP_JITTER_MAX_SECONDS) * 1000;

export const shouldJitterAnonymousTimestamp = (
  eventName: string,
  properties: Record<string, unknown>
): boolean =>
  isAnonymousTimestampJitterEvent(eventName) &&
  (eventName !== 'account_login' || properties.login_method !== 'auto');
